<template>
  <div class="section" id="profile-edit">
    <h1 class="pagetitle">プロフィール</h1>
    <div class="columns">
      <div class="column">
        <PhotoPreview v-model="photoFile" :currentSrc="photoURL" />
        <NicknameTextField class="shorttextbox" v-model="nickname" />

        <b-field label="誕生日" v-if="birthDate">
          <b-input class="shorttextbox" type="text" v-model="birthDate" disabled />
        </b-field>

        <b-field label="メールアドレス" v-if="email">
          <b-input type="text" v-model="email" disabled />
        </b-field>

        <div class="buttonwrap has-text-centered">
          <b-button
            class="button elkatsubutton--base"
            @click="submitForm"
            :loading="submitting"
          >
            更新する
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NicknameTextField from '@/components/Molecules/NicknameTextField';
import PhotoPreview from '@/components/Molecules/PhotoPreview';
import moment from 'moment';
import profileMixin from '@/mixins/profileMixin'

const DEAFULT_PHOTO_URL =
  'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';

export default {
  name: 'Profile',
  mixins: [profileMixin],
  components: {
    NicknameTextField,
    PhotoPreview
  },
  data() {
    return {
      photoFile: null,
      photoURL: '',
      selfIntroduction: '',
      submitting: false
    };
  },
  async created() {
    await this.loadProfile(this.$store.state.auth.uid);
  },
  computed: {
    birthDate() {
      const birthDate = this.$store.state.user.birthDate;
      if (!birthDate) {
        return '';
      }
      return moment.unix(birthDate.seconds).format('YYYY/MM/DD');
    },
    uid() {
      return this.$store.state.auth.uid;
    },
    email() {
      return this.$store.state.auth.email;
    }
  },
  methods: {
    async loadProfile(uid) {
      let userId = uid;
      await this.$store.dispatch('user/loadUserDoc', userId);
      this.photoURL = this.$store.state.user.photoURL
        ? this.$store.state.user.photoURL
        : DEAFULT_PHOTO_URL;

      this.nickname = this.$store.state.user.nickname;
      this.selfIntroduction = this.$store.state.user.selfIntroduction;
    },
    async submitForm() {
      this.submitting = true;

      let validateResult = await this.validate();
      if (!validateResult) {
        this.submitting = false;
        return;
      }

      try {
        await this.$store.dispatch('updateUserProfile', {
          nickname: this.nickname,
          photoFile: this.photoFile,
          selfIntroduction: this.selfIntroduction
        });
        this.$buefy.toast.open({
          message: 'プロフィールがアップデートされました',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        this.$buefy.toast.open({
          message: 'プロフィールのアップデートが失敗しました',
          type: 'is-danger'
        });
      }
      this.submitting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/profile-edit.scss';

.floatable-preview {
  position: relative;
}

.floating-camera-icon {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.75);
  border-radius: 50%;
  bottom: 8%;
  right: 8%;
  padding: 8%;
}
.floating-camera-icon:hover {
  cursor: pointer;
}
.field.has-addons .control:not(:last-child) {
  width: 100%;
}
.tags-display {
  margin-bottom: 10px;
}
</style>
